// extracted by mini-css-extract-plugin
module.exports = {"breadcrumps":"AdvertisersListPage_breadcrumps__OP94A"};